import { render, staticRenderFns } from "./formApplicant.vue?vue&type=template&id=540114aa&scoped=true"
import script from "./formApplicant.vue?vue&type=script&lang=js"
export * from "./formApplicant.vue?vue&type=script&lang=js"
import style0 from "./formApplicant.vue?vue&type=style&index=0&id=540114aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540114aa",
  null
  
)

export default component.exports